import React from "react";
import styled from "styled-components";

import searchIcon from "../assets/loupe.svg";

const SearchButton = (props: any) => {
  const { className } = props;
  return (
    <Wrapper className={className}>
      <img src={searchIcon} alt="bag-icon" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  color: #979797;
  display: flex;
  pointer: cursor;

  img {
    height: 32px;
    filter: invert(61%) sepia(0%) saturate(0%) hue-rotate(238deg)
      brightness(98%) contrast(97%);
  }
`;

export default SearchButton;
